(function(){
  'use strict';
  function init(scope){
    (scope||document).querySelectorAll('[data-bb-product]').forEach(function(root){
      if(root.dataset.pdpReady==='1')return;
      root.dataset.pdpReady='1';
      var form=root.querySelector('.bb-pdp__form');
      if(!form)return;
      var selected=root.querySelector('[data-pdp-variant-id]');
      var gallery=root.querySelector('#BBPdpMainImage');
      var atc=root.querySelector('[data-pdp-add]');
      var label=root.querySelector('[data-pdp-add-label]');
      var sticky=root.querySelector('[data-pdp-sticky]');
      var stickyButton=root.querySelector('[data-pdp-sticky-add]');
      var stickyLabel=root.querySelector('[data-pdp-sticky-label]');
      var quantity=root.querySelector('[data-pdp-qty-input]');
      var info=root.querySelector('[data-pdp-message]');
      var wasSubmitting=false;
      function imageSwap(src,alt){
        if(!src||!gallery)return;
        gallery.src=src;gallery.removeAttribute('srcset');gallery.removeAttribute('sizes');
        if(alt)gallery.alt=alt;
        var z=root.querySelector('[data-pdp-zoom-image]');if(z){z.src=src;z.alt=gallery.alt;}
        root.querySelectorAll('[data-pdp-thumb]').forEach(function(b){
          var picked=b.dataset.image===src;
          b.classList.toggle('is-selected',picked);b.setAttribute('aria-pressed',String(picked));
        });
      }
      root.querySelectorAll('[data-pdp-thumb]').forEach(function(b){
        b.addEventListener('click',function(){imageSwap(b.dataset.image,b.dataset.alt)});
      });
      function pickVariant(v){
        if(!v||!selected)return;
        selected.value=v.dataset.variantId||v.value;
        var available=v.dataset.variantAvailable==='true';
        var price=root.querySelector('[data-pdp-price]');
        if(price){price.replaceChildren();var current=document.createElement('span');current.textContent=v.dataset.variantPrice||'';price.append(current);if(v.dataset.variantCompare){var old=document.createElement('s');old.textContent=v.dataset.variantCompare;price.append(old);}}
        var barcode=root.querySelector('[data-pdp-barcode]');if(barcode)barcode.textContent=v.dataset.variantBarcode||'—';
        var title=root.querySelector('[data-pdp-current-variant]');if(title)title.textContent=v.dataset.variantTitle||'';
        atc.disabled=!available;if(label)label.textContent=available?'ADD TO CART':'SOLD OUT';
        if(stickyButton)stickyButton.disabled=!available;
        if(stickyLabel)stickyLabel.textContent=available?'Add to Cart':'Sold out';
        root.querySelectorAll('[data-pdp-variant]').forEach(function(button){var isCurrent=button.dataset.variantId===selected.value;button.classList.toggle('is-selected',isCurrent);button.setAttribute('aria-pressed',String(isCurrent));});
        if(v.dataset.variantImage)imageSwap(v.dataset.variantImage,v.dataset.variantTitle);
        if(info){info.textContent='';info.removeAttribute('data-success')}
        try{var url=new URL(window.location.href);url.searchParams.set('variant',selected.value);window.history.replaceState(window.history.state,'',url.toString());}catch(e){}
      }
      root.querySelectorAll('[data-pdp-variant]').forEach(function(button){button.addEventListener('click',function(){pickVariant(button)})});
      var select=root.querySelector('[data-pdp-variant-select]');if(select)select.addEventListener('change',function(){pickVariant(select.selectedOptions[0])});
      function changeQty(delta){
        if(!quantity)return;
        var min=Number(quantity.min)||1,max=quantity.max?Number(quantity.max):Infinity,step=Number(quantity.step)||1;
        var newValue=(Number(quantity.value)||min)+delta*step;
        quantity.value=String(Math.max(min,Math.min(max,newValue)));
      }
      var minus=root.querySelector('[data-pdp-qty-down]'),plus=root.querySelector('[data-pdp-qty-up]');
      if(minus)minus.addEventListener('click',function(){changeQty(-1)});
      if(plus)plus.addEventListener('click',function(){changeQty(1)});
      if(quantity)quantity.addEventListener('change',function(){quantity.value=String(Math.max(Number(quantity.min)||1,Math.min(quantity.max?Number(quantity.max):Infinity,Number(quantity.value)||1)))});
      root.querySelectorAll('[data-pdp-dialog-open]').forEach(function(btn){
        btn.addEventListener('click',function(){var dialog=document.getElementById(btn.getAttribute('data-pdp-dialog-open'));if(dialog&&typeof dialog.showModal==='function')dialog.showModal()});
      });
      root.querySelectorAll('[data-pdp-dialog-close]').forEach(function(btn){btn.addEventListener('click',function(){var dialog=btn.closest('dialog');if(dialog)dialog.close()})});
      root.querySelectorAll('dialog').forEach(function(dialog){dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close()})});
      if(stickyButton)stickyButton.addEventListener('click',function(){if(!atc.disabled){if(form.requestSubmit)form.requestSubmit(atc);else atc.click();}});
      if(sticky&&atc&&'IntersectionObserver'in window){
        var observer=new IntersectionObserver(function(entries){
          var visible=entries[0].isIntersecting;
          sticky.classList.toggle('is-visible',!visible);
          sticky.setAttribute('aria-hidden',String(visible));
        },{threshold:0});observer.observe(atc);
      }
      form.addEventListener('submit',function(e){
        if(wasSubmitting){e.preventDefault();return}
        if(!window.fetch||!window.FormData)return;
        e.preventDefault();
        if(!selected.value||atc.disabled)return;
        wasSubmitting=true;atc.disabled=true;atc.setAttribute('aria-busy','true');
        if(label)label.textContent='ADDING…';
        if(stickyButton)stickyButton.disabled=true;
        if(info)info.textContent='';
        var data=new FormData(form);
        // Shopify's /cart/add.js expects form variant ID and quantity.
        var rootPath=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
        fetch(rootPath+'cart/add.js',{method:'POST',body:data,headers:{'Accept':'application/json'}})
          .then(function(response){return response.json().then(function(body){if(!response.ok)throw new Error(body.description||body.message||'Unable to add this product.');return body})})
          .then(function(){if(info){info.textContent='Added to your bag.';info.dataset.success='true'}document.dispatchEvent(new CustomEvent('bb:cart:open'))})
          .catch(function(error){if(info){info.textContent=error.message||'Please try again.';info.removeAttribute('data-success')}})
          .finally(function(){wasSubmitting=false;atc.removeAttribute('aria-busy');var active=root.querySelector('[data-pdp-variant].is-selected')||(select?select.selectedOptions[0]:null);
            var available=active?active.dataset.variantAvailable==='true':true;
            atc.disabled=!available;if(label)label.textContent=available?'ADD TO CART':'SOLD OUT';if(stickyButton)stickyButton.disabled=!available;
          });
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
